import React from "react";
import { Radio, Steps } from "antd";
import { useHistory } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";

function Stepper(props) {
  return (
    <div>
      <Steps
        style={{ marginBottom: 20 }}
        size="small"
        items={[
          {
            title: "Open",
            status: props.status === "OPEN" ? "process" : "finish",
            icon: props.status === "OPEN" ? <LoadingOutlined /> : false,
          },
          {
            title: "Update Details",
            status:
              props.status === "UPDATE"
                ? "process"
                : props.status === "OPEN"
                ? "wait"
                : "finish",
            icon: props.status === "UPDATE" ? <LoadingOutlined /> : false,
          },
          {
            title: "Complete",
            status: props.status === "COMPLETE" ? "finish" : "wait",
            icon: false,
          },
        ]}
      />
    </div>
  );
}

export default Stepper;
